/**
 * @group Configs
 * 
 * @summary
 * <blockquote>Global error handler resource configuration</blockquote>
 * 
 * @remarks
 * This configuration is used for global error handlers that catch uncaught exceptions
 * and unhandled promise rejections. It uses the ERROR module resource and logs errors
 * to console in development, and to Sentry in preview and production environments.
 * 
 * @example
 * ```typescript
 * import { GLOBAL_ERROR_CONFIG } from '@shared/config';
 * import { setupGlobalErrorHandlers } from '@shared/logger';
 * 
 * await setupGlobalErrorHandlers(GLOBAL_ERROR_CONFIG);
 * ```
 */

import { ResourceConfig } from '../interfaces/ResourceConfig';
import { ResourceType } from '@shared/utils';
import { MODULE_RESOURCES } from '@shared/utils';
import { REPORTING_TRANSPORTS } from '../constants/REPORTING_TRANSPORTS';

export const GLOBAL_ERROR_CONFIG: ResourceConfig = {
  auth: {
    type: ResourceType.MODULE,
    resource: MODULE_RESOURCES.ERROR,
    verbs: [],
    requireAuth: false,
  },
  logs: {
    development: {
      level: 'info',
      transport: 'console', // Development: Console for debugging
    },
    preview: {
      level: 'info',
      transport: 'sentry',
    },
    production: {
      level: 'error',
      transport: 'sentry',
    },
  },
  reporting: {
    development: {
      transport: REPORTING_TRANSPORTS.CONSOLE,
      samplingRate: 1.0,
      consoleFormat: 'json',
    },
    preview: {
      transport: REPORTING_TRANSPORTS.POSTHOG,
      samplingRate: 1.0,
    },
    production: {
      transport: REPORTING_TRANSPORTS.POSTHOG,
      samplingRate: 1.0,
    },
  },
};

